import React from 'react';
import './RecommendationsCarousel.css';

const RecommendationsCarousel = ({ recommendations }) => {
  return (
    <div className="recommendations-carousel">
      {recommendations.map((rec, index) => (
        <div key={index} className="recommendation-card-carousel">
          <img src={rec.image} alt={rec.name} />
          <div className="recommendation-card-carousel-overlay">
            <h3>{rec.name}</h3>
            <p>{rec.description}</p>
            <p className="pairing"><em>{rec.pairing}</em></p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecommendationsCarousel;
